<template>
  <div class="login">
    <div class="login-background"></div>
    <div class="uk-flex uk-flex-middle uk-flex-center login-container">      
      <div class="uk-width-large">
        <vk-card>
          <vk-card-title>Login</vk-card-title>
          <form @submit.prevent="login" method="POST">
            <div class="uk-margin">
              <input class="uk-input" v-model.trim="email" name="email" type="email" placeholder="Email" required>
            </div>
            <div class="uk-margin">
              <input class="uk-input" v-model.trim="password" name="password" type="password" placeholder="Password" required>
            </div>
            <div class="login-error" v-if="infoError">Credenziali non valide<br><br></div>
            <input type="submit" class="uk-button uk-button-primary" value="Login">
          </form>
        </vk-card>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .login, .login-container {
    width: 100%;
    height: 100%;
  }

  .login-container {
    background-image: url("../assets/background.jpg");

    /* Full height */
    width: 100%;
    height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login-error {
    color: red;
  }
</style>

<script>
import config from '@/config'

export default {
  name: 'login',

  components: {},

  beforeCreate () {
    if (this.$store.state.isLogged) {
      this.$router.push('/')
    }
  },

  data () {
    return {
      email: "",
      password: "",
      infoError: false
    }
  },

  methods: {
    login () {
      this.infoError = false

      var formData = new FormData()
      formData.append('email', this.email)
      formData.append('password', this.password)

      this.$http.post(config.API_URL + '/login',
        formData
      ).then((response) => {
        let token = response.body.token

        this.$http.get(config.API_URL + '/userInfo', {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }).then(
          (response) => {
            localStorage.setItem('token', token)

            if (response.body.admin == 1)
              this.$store.commit('LOGIN_ADMIN')
            else
              this.$store.commit('LOGIN_USER')
            
            this.$store.dispatch('REFRESH_USER_DEVICES', this.$http)
            
            this.$router.push('/')
          }, (err) => {
            console.log(err)
            this.infoError = true
            this.password = ""
          }
        )
        
      }, (err) => {
        console.log(err)
        this.infoError = true
        this.password = ""
      })
    }
  }
}
</script>
